import { atom } from "recoil";
import PackageUmrahModel from "../Models/packageUmrahModel";
export const PackageUmrahAtom = atom({
  key: "PackageUmrahAtom", // unique ID (with respect to other atoms/selectors)
  default: new PackageUmrahModel(), // default value (aka initial value)
});
